// -----------------------------------------------------------------------------
// PLUGINS/NAV
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
import { elt, setClass } from "../util/dom";
import icons from "../util/icons";
// -----------------------------------------------------------------------------
export class BlockMenuView {
    constructor(editor, key, items, id, app, container) {
        this.items = items.map(f => f(editor, key, id, app, container));
        this.editor = editor;
        this.range = 4;
        this.position = this.range;
        this.hold = null;
        this.arrowLeft = elt("div", {
            className: "df-ed-mu__shift df-ed-mu__shift--left",
            onclick: () => this.shiftLeft()
        }, icons.chevronLeft("df-ed-mu__shift-icon"));
        this.arrowRight = elt("div", {
            className: "df-ed-mu__shift df-ed-mu__shift--right",
            onclick: () => this.shiftRight()
        }, icons.chevronRight("df-ed-mu__shift-icon"));
        this.dom = elt("div", {
            className: "df-ed-mu df-ed-mu--story"
        }, this.arrowLeft, elt("div", {
            className: "df-ed-mu__container df-ed-mu__container--story"
        }, ...this.items.map(item => item.dom)), this.arrowRight);
        this.dom.addEventListener("touchstart", (event) => {
            this.hold = [event.changedTouches[0].clientX, 0];
        });
        this.dom.addEventListener("mousedown", (event) => {
            this.hold = [event.clientX, 0];
        });
        this.dom.addEventListener("touchmove", (event) => {
            if (this.hold !== null) {
                let [start, change] = this.hold;
                let next = start - event.changedTouches[0].clientX;
                if (Math.abs(next) >= 60) {
                    this.hold = [event.changedTouches[0].clientX, 0];
                    if (next > 0) {
                        this.shiftRight();
                    }
                    else {
                        this.shiftLeft();
                    }
                }
                else {
                    this.hold = [start, next];
                }
            }
        });
        this.dom.addEventListener("mousemove", (event) => {
            if (this.hold !== null) {
                let [start, change] = this.hold;
                let next = start - event.clientX;
                if (Math.abs(next) >= 60) {
                    this.hold = [event.clientX, 0];
                    if (next > 0) {
                        this.shiftRight();
                    }
                    else {
                        this.shiftLeft();
                    }
                }
                else {
                    this.hold = [start, next];
                }
            }
        });
        this.dom.addEventListener("touchend", () => {
            this.hold = null;
        });
        this.dom.addEventListener("mouseup", () => {
            this.hold = null;
        });
        this.dom.addEventListener("mouseleave", () => {
            this.hold = null;
        });
        this.dom.addEventListener("wheel", event => {
            event.preventDefault();
            if (event.deltaX < 0) {
                this.shiftRight();
            }
            if (event.deltaX > 0) {
                this.shiftLeft();
            }
        });
        window.addEventListener("resize", () => {
            if (this.setRange() === this.range)
                return;
            else
                this.update();
        });
    }
    shiftLeft() {
        const pos = Math.max(this.position - 1, this.range);
        if (pos === this.position) {
            return;
        }
        else {
            this.position = pos;
            this.update();
        }
    }
    shiftRight() {
        const pos = Math.min(this.position + 1, this.items.length);
        if (pos === this.position) {
            return;
        }
        else {
            this.position = pos;
            this.update();
        }
    }
    setRange() {
        if (window.innerWidth <= 600) {
            return Math.min(this.items.length, Math.floor(this.dom.offsetWidth / 120));
        }
        else {
            return Math.min(this.items.length, Math.floor(this.dom.offsetWidth / 80));
        }
    }
    resetPosition() {
        const position = Math.max(this.range, this.position);
        return Math.min(this.items.length, position);
    }
    inRange(n) {
        return n + 1 > this.position - this.range && n + 1 <= this.position;
    }
    update() {
        this.range = this.setRange();
        this.position = this.resetPosition();
        this.items.forEach((item, i) => {
            item.update();
            setClass(item.dom, "visible", this.inRange(i));
            setClass(item.dom, "df-ed-mu__item--active", item.active(this.editor.state));
        });
        const disableLeft = this.position === this.range;
        const disableRight = this.position === this.items.length;
        const hideArrows = this.range === this.items.length;
        setClass(this.arrowLeft, "df-ed-mu__shift--disabled", disableLeft);
        setClass(this.arrowRight, "df-ed-mu__shift--disabled", disableRight);
        setClass(this.arrowLeft, "df-ed-mu__shift--hidden", hideArrows);
        setClass(this.arrowRight, "df-ed-mu__shift--hidden", hideArrows);
    }
    destroy() {
        this.items.forEach((item, i) => {
            if (item.destroy) {
                item.destroy();
            }
        });
        this.dom.remove();
    }
}
export class InlineMenuView {
    constructor(editor, key, items, id, app) {
        this.items = items.map(f => f(editor, key, id, app));
        this.editor = editor;
        this.items.forEach(item => { setClass(item.dom, "visible", true); });
        this.dom = elt("div", {
            className: "df-ed-mu df-ed-mu--inline"
        }, elt("div", {
            className: "df-ed-mu__container df-ed-mu__container--inline"
        }, ...this.items.map(item => item.dom)));
    }
    update() {
        this.items.forEach((item) => {
            item.update();
            setClass(item.dom, "df-ed-mu__item--active", item.active(this.editor.state));
        });
    }
    destroy() {
        this.items.forEach((item) => {
            if (item.destroy) {
                item.destroy();
            }
        });
        this.dom.remove();
    }
}
